import { TRootState } from 'Redux/Reducers';

export const getEmployeeCount = (state: TRootState) => state.employee.maxCount;
